import { uniqueId } from "lodash-es";
import { getCookie, setCookie } from "@/utils/cookiesUtils";

const USER_ID_COOKIE_EXPIRATION = 365 * 24 * 60 * 60 * 1000;

export function getUserSessionStatus() {
  const userId = getCookie("user_id");
  const sessionStatus = getCookie("session_status") as "new" | "return" | undefined;

  let status: "new" | "return";

  if (!userId) {
    setCookie("user_id", uniqueId(), { expires: new Date(Date.now() + USER_ID_COOKIE_EXPIRATION) });
    status = "new";
  } else if (!sessionStatus) {
    status = "return";
  } else {
    status = sessionStatus;
  }

  setCookie("session_status", status);

  return { status };
}
